import { render, staticRenderFns } from "./YoutubeLink.vue?vue&type=template&id=d7c8f07a&scoped=true&"
import script from "./YoutubeLink.vue?vue&type=script&lang=js&"
export * from "./YoutubeLink.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeLink.vue?vue&type=style&index=0&id=d7c8f07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c8f07a",
  null
  
)

export default component.exports